import isString from "lodash/isString";

function isValidIdentifier(identifier) {
    return isString(identifier) && identifier.length === 24;
}

export default isValidIdentifier;